import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { Coleccionista, ColeccionistasResponse, DataColeccionista } from 'app/models/coleccionitas.model';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { BehaviorSubject } from 'rxjs';
import { BienesFilterParams } from '../bienes-culturales/bienes-culturales-list/filtro/models/bienes-filter-params';
import { UtilsService } from 'app/modules/utils-service';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';
import { ActualizarColeccionista } from './models/actualizar-coleccionista';

@Injectable({providedIn: 'root'})
export class ColeccionistasService {
    coleccionistas:BehaviorSubject<ColeccionistasResponse>= new BehaviorSubject<ColeccionistasResponse>(null)
    coleccionistasFilterParams: BehaviorSubject<BienesFilterParams> = new BehaviorSubject(null)
    coleccionista:BehaviorSubject<DataColeccionista>= new BehaviorSubject<DataColeccionista>(null)
    bitacoraColeccionista=new BehaviorSubject<BitacoraActividadesInterface[]>([]);
    
    constructor(
        private apiService:ApiService,
        private utilsService:UtilsService
    ) { }

    get coleccionistas$(){
        return this.coleccionistas.asObservable()
    }

    set coleccionistasFilterParmas(value: any) {
        this.coleccionistasFilterParams.next(value);
    }

    get coleccionistasFilterParmasValue() {
        return this.coleccionistasFilterParams.getValue()
    }

    get coleccionista$(){
        return this.coleccionista.asObservable()
    }

    get bitacoraColeccionista$(){
        return this.bitacoraColeccionista.asObservable();
    }

    getColeccionistas(params?:any){
        const url='/coleccionista'
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener listado de Coleccionistas.')
                .subscribe((response: ColeccionistasResponse) => {
                    this.coleccionistas.next(response)
                    resolve(response)            
                }, error => {
                    reject(true)
                })
        })
    }

    postColeccionistas(body?:any){
        const url='/coleccionista'
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body,{}, 'Error al guardar Coleccionista.')
                .subscribe((response: ColeccionistasResponse) => {
                    resolve(response)            
                }, error => {
                    reject(true)
                })
        })
    }

    getTipologias(tipologia_id?:number){
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener tipología.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    getColecciones(){
        const url= `/tipologias/colecciones` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener Colecciones.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    deleteColeccionista(uu_id:string){
        const url= `/coleccionista/${uu_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.DeleteMethod(url, {}, 'Error al eliminar Coleccionista.')
                .subscribe(response => {
                    resolve(true)  
                }, error => {
                    reject(error)
                })
        })
    }

    getColeccionitaPorUuid(uuid:string){
        const params= {coleccionistaUuid:uuid}
        const url= `/coleccionista` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener Coleccionista.')
                .subscribe((response: ColeccionistasResponse) => {

                    const data = response.data[0];
                    
                    if (data) {
                        const coleccionista = data;

                        if (coleccionista.archivoFavorito !== 0) {
                            this.utilsService.getArchivosInternos(coleccionista.archivoFavorito)
                                .then((blobURL) => {
                                    coleccionista.blobURL = blobURL;
                                    this.coleccionista.next(coleccionista);
                                })
                                .catch(() => {
                                    this.coleccionista.next(coleccionista);
                                });
                        } else {
                            this.coleccionista.next(coleccionista);
                        }
                    }

                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    postIdentificacionColeccionista(coleccionistaUuid:string, body:any){
        const url= `/coleccionista/subir_archivo/${coleccionistaUuid}` 
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, body, {}, 'Error al guardar Identificación del Coleccionista.')
                .subscribe((response) => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getBitacoraColeccionista(_entidadUuid:string){
        const url='/bitacoras'
        const params= {entidadUuid:_entidadUuid}
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: any) => {
                    this.bitacoraColeccionista.next(response.data);  
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }

    actualizarColeccionista(body:ActualizarColeccionista, coleccionista_uuid:string){
        const url=`/coleccionista/${coleccionista_uuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al actualizar los datos.')
                .subscribe((response: any) => {
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }

    
}